const full = process.env.REACT_APP_FEATURES === 'full';

export const features = {
  auth: full,
  ark: full,
  metrics: full,
  paper: full,
};
